<template></template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    name: "PreviewVisibilityMixin",
    computed: {
        ...mapGetters("user", ["isLoggedIn"]),
        ...mapGetters("pages", ["isCourse"]),
        ...mapState("products",["courses"]),
        visibility() {
            return this.myData?.itemVisibilitySettings?.value || false;
        },
        course(){
          if ( !this.isCourse ){
            return false;
          }
          return this.courses.find( course => course.titleId === this.pageContext.params.slug);            
        },
        enrolled(){
          let enrolled = false;
          if ( this.course ){            
            if ( this.course?.status === "paid"){
              enrolled = this.course.me?.premium;
            } else if ( this.course?.status === "free" ){
              enrolled = this.course.me?.registered;
            }
          }
          return enrolled;
        },
        status(){
          const statusObj = {
            "logged-out": () => !this.isLoggedIn,
            "logged-in": () => this.isLoggedIn,
            "enrolled": () => this.isLoggedIn && this.enrolled,
            "unenrolled": () => this.isLoggedIn && !this.enrolled,
            "tagged": () => {
              const tags = this.myData?.itemVisibilitySettings?.data || [];
              return this.isLoggedIn && me.tags && me.tags.filter( tag => tags.includes(tag)).length > 0;
            }
          };
          let targetStatus = this.myNode.dataset.visibility;
          let currentStatus = null;
          
          if ( targetStatus && statusObj.hasOwnProperty(targetStatus) && statusObj[targetStatus]() ){
            currentStatus = targetStatus
          }
          return currentStatus;
        },
    },
    methods: {
        checkVisibility() {
          if ( this.myNode.dataset.visibility && this.status ){
            this.myNode.dataset.currentStatus = this.status;
          } else {
            this.myNode.removeAttribute("data-current-status")
          } 
        }
    },
    watch: {
      isLoggedIn(){
        this.checkVisibility();
      },
      "course.me": {
        handler(val){
          this.checkVisibility();
        }
      }
    }
};
</script>

